// Stimulus
import { Application } from '@hotwired/stimulus';
import StimulusControllerResolver from 'stimulus-controller-resolver';

// Turbo
import * as Turbo from '@hotwired/turbo';

// Assets
import '../assets/img/logo-large.svg';
import '../assets/img/logo-mark.svg';
import '../assets/img/logo.svg';
import '../assets/img/logo.png';
import '../assets/img/pattern-footer.svg';
import '../assets/img/maintenance-sticker.webp';
import '../assets/img/fabrics.webp';

// Icons
import '../assets/img/icons/arrow-long-left.svg';
import '../assets/img/icons/arrow-long-right.svg';
import '../assets/img/icons/arrow-top-right-on-square.svg';
import '../assets/img/icons/arrow-down-tray.svg';
import '../assets/img/icons/bars-3.svg';
import '../assets/img/icons/chevron-down.svg';
import '../assets/img/icons/envelope.svg';
import '../assets/img/icons/facebook.svg';
import '../assets/img/icons/globe-europe-africa.svg';
import '../assets/img/icons/instagram.svg';
import '../assets/img/icons/linkedin.svg';
import '../assets/img/icons/minus-circle.svg';
import '../assets/img/icons/phone.svg';
import '../assets/img/icons/play.svg';
import '../assets/img/icons/plus-circle.svg';
import '../assets/img/icons/plus.svg';
import '../assets/img/icons/spinner.svg';
import '../assets/img/icons/tiktok.svg';
import '../assets/img/icons/whatsapp.svg';
import '../assets/img/icons/x-mark.svg';
import '../assets/img/icons/youtube.svg';

// Start Stimulus
const application = Application.start();
StimulusControllerResolver.install(application, async (controllerName) => (
  (await import(`./controllers/${controllerName}_controller.js`)).default
));

// Start Turbo
Turbo.start();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR');
  });
}
